import { useMemo } from 'react';

import { SlicerMode } from '@/engine/app/modules/images/interfaces';

import type { ImagesService } from '@/engine/app/modules/images/Images.service.ts';
import type { ViewsService } from '@/engine/app/Views.service';
import type { IImagesInfo, SliceType } from '@/engine/app/modules/images/interfaces';
import type { ICenterLineViewModel } from '@/engine/app/interfaces.ts';

export const useRelatedInfo = (
  viewsService: ViewsService,
  imagesService: ImagesService,
  sliceType: SliceType
): {
  imagesInfo: IImagesInfo;
  centerLines: Array<ICenterLineViewModel>;
  isLongAxisMode: boolean;
  slicerMode: SlicerMode;
} => {
  const imagesInfo = useMemo(() => imagesService.getImageSliceOrientationInfo(sliceType), [imagesService, sliceType]);

  const centerLines = useMemo(
    () => viewsService.currentViewOrThrow.getCenterLines(),
    [viewsService.currentViewOrThrow]
  );

  const isLongAxisMode: boolean = useMemo(
    () => Boolean(centerLines.find((cl) => cl.descriptor === 'long_axis.centerline')),
    [centerLines]
  );

  const slicerMode = useMemo(() => {
    if (imagesService.activeXRaySlicer?.[0] === sliceType) {
      return imagesService.activeXRaySlicer[1];
    } else {
      return SlicerMode.SINGLE;
    }
  }, [imagesService.activeXRaySlicer, sliceType]);

  return { imagesInfo, centerLines, isLongAxisMode, slicerMode };
};
